import { Checkbox } from "@/components/ui/checkbox";
import { COLUMNS } from "../products.constants";
import { ArrowUpDown } from "lucide-react";
import { IProduct } from "../products.interface";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setFilters, setSelectedProducts } from "../products.slice";
import ProductRow from "./ProductRow";
import { useEffect } from "react";
import { getProducts } from "../products.action";
import { Loader2 } from "lucide-react";

export default function ProductsTable() {
  // Hooks
  const dispatch = useAppDispatch();

  // Redux
  const { selectedProducts, filters, products, isGetProductLoading } =
    useAppSelector((state) => state.products);

  useEffect(() => {
    dispatch(getProducts(filters));
  }, [filters]);

  const onSelectAll = () => {
    if (selectedProducts.length === products.length) {
      dispatch(setSelectedProducts([]));
    } else {
      dispatch(setSelectedProducts(products.map((product) => product._id)));
    }
  };

  const onHeaderClick = (column: string) => {
    dispatch(
      setFilters({
        ...filters,
        sort: column,
        order: filters.order === "asc" ? "desc" : "asc",
      })
    );
  };

  if (isGetProductLoading) {
    return (
      <div className="flex justify-center items-center h-1/2">
        <Loader2 className="animate-spin" />
      </div>
    );
  }

  return (
    <div className="border">
      <div className="grid grid-cols-(--product-table-header) gap-4 bg-muted p-4 border items-center">
        <div>
          <Checkbox
            className="border-primary"
            onClick={onSelectAll}
            checked={selectedProducts.length === products.length}
          />
        </div>
        {COLUMNS.map((column) => {
          return (
            <div
              key={column.key}
              className="text-muted-foreground font-medium text-sm text-center flex justify-center items-center gap-1"
            >
              {column.title}{" "}
              {column.sortable && (
                <ArrowUpDown
                  size={12}
                  className={`cursor-pointer ${
                    filters.sort === column.key && filters.order === "asc"
                      ? "text-primary"
                      : "text-muted-foreground"
                  }`}
                  onClick={() => onHeaderClick(column.key)}
                />
              )}
            </div>
          );
        })}
        <div></div>
      </div>

      {products.length === 0 && (
        <div className="flex justify-center items-center h-40">
          <span className="text-muted-foreground italic">
            No Products Found
          </span>
        </div>
      )}

      {/* Rows */}
      {products.map((product: IProduct) => {
        return <ProductRow key={product._id} product={product} />;
      })}
    </div>
  );
}
